export default __webpack_public_path__ + "static/media/azure.f99275e8.svg";